<template>
  <div class="component_card">
    <div
      class="column text_m_blu tal_c p30-l-r main_blue_dk_bg"
      style="font-size: 18px; color: white; border-radius: 8px 8px 0px 0px"
    >
      <span>
        {{ $t("msg.available_balance") }} {{ this.getUnlockedBalance() }} BLUE
      </span>
    </div>
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column">
          <div
            style="
              display: flex;
              justify-content: center;
              margin-bottom: 30px;
              flex-direction: column;
            "
          >
            <div style="width: 100%; display: flex; justify-content: center">
              <img
                class="blu_balance_img"
                src="../../../../assets/images/3.png"
              />
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                font-size: 9px;
              "
            >
              <div style="width: 60%; display: flex; justify-content: center">
                <span style="margin-left: 10px; color: #02b9a4">{{
                  $t("msg.step_amount")
                }}</span>
                <span style="margin-left: 25px; color: #02b9a4">{{
                  $t("msg.step_recipient")
                }}</span>
                <span style="margin-left: 25px; color: #02b9a4">{{
                  $t("msg.step_verification")
                }}</span>
                <span style="margin-left: 20px">{{
                  $t("msg.step_authentication")
                }}</span>
              </div>
            </div>
          </div>

          <p class="tal_c main_blue_dk_fill fat" style="margin-bottom: 30px">
            {{ $t("msg.verify_step") }}
          </p>

          <div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
              "
            >
              <!-- <p style="font-size: 14px">
                {{ $t("msg.check_info_redeem") }}
              </p> -->
            </div>
          </div>

          <div style="font-size: 14px">
            <div
              style="
                border-bottom: #ccc solid 2px;
                padding: 15px;
                padding-left: 15px;
              "
            >
              <p class="fat">{{ $t("msg.redeeming") }}</p>
              <p style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px">
                {{ previewData.sourceAmount }} BLUE
              </p>
            </div>
            <div
              style="
                border-bottom: #ccc solid 2px;
                padding: 15px;
                padding-left: 15px;
              "
            >
              <p class="fat">{{ $t("msg.receiving") }}</p>
              <p style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px">
                {{ $t("msg.subtotal") }}:
                {{
                  (previewData.sourceAmount * previewData.targetPrice).toFixed(
                    2
                  )
                }}
                USDT
              </p>
              <p style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px">
                <span>
                  {{ $tc("msg.fee", 1) }}:
                  {{ getFeeToShow() }}
                  USDT
                </span>
              </p>

              <p
                style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px"
                class="fat"
              >
                Total:
                {{ getTotal() }}
                USDT
              </p>
            </div>
            <div style="padding: 15px; padding-left: 15px">
              <p class="fat">{{ $t("msg.send_to_btc_adress") }}</p>
              <p style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px">
                {{ address }}
              </p>
              <p
                class="fat"
                style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px"
              >
                Network: TRC20
              </p>
              <p style="margin-left: 15px; margin-top: 5px; margin-bottom: 5px">
                {{ $t("msg.delivery_speed") }}:
                <span v-if="redeemtype"> {{ $t("msg.today") }}</span>
                <span v-else> 3 {{ $t("msg.business_day") }}</span>
              </p>
            </div>
          </div>

          <div style="display: flex; align-items: center; margin-top: 40px">
            <input
              type="checkbox"
              id="checkbox"
              v-model="checked"
              style="width: 22px; margin-right: 10px"
            />
            <span>{{ $t("msg.check_info_redeem") }}</span>
          </div>

          <div style="display: flex; margin-top: 20px">
            <button
              class="btn_redeem_back btn_radius"
              style="background: #e12d2d; width: 30%"
              @click="callBackStep()"
            >
              {{ $t("msg.back") }}
            </button>
            <button
              class="btn_redeem btn_radius"
              style="width: 30%"
              @click="callNextStep()"
              :disabled="!this.checked"
            >
              {{ $t("msg.next_step") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  props: [
    "previewData",
    "address",
    "redeemtype",
    "feeFixed",
    "feeTaxRush",
    "feeTax",
  ],
  created() {
    this.getRedeemFee();
    this.getRedeemInfo();
  },
  mounted() {},
  data: () => ({
    feeRedeem: "",
    usdtAddress: "",
    blockButton: true,
    picked: "",
    checked: "",
    redeemInfo: "",
  }),
  components: {},
  methods: {
    async getRedeemInfo() {
      let resp = await this.$store.dispatch("getRedeemInfo");
      this.redeemInfo = resp.data;
    },
    getFeeToShow() {
      let feePecent = this.getTotalFeePerent();
      let fee;

      if (feePecent > this.feeFixed.fee) {
        fee = feePecent;
      } else {
        fee = this.feeFixed.fee;
      }

      if (this.redeemtype) {
        fee += this.feeTaxRush.fee;
      }

      console.log(this.redeemInfo);

      if (this.redeemInfo.wave) {
        let result =
          this.previewData.sourceAmount * this.previewData.targetPrice;

        if (result <= this.redeemInfo.waveRule) {
          fee = 2;
        }
      }

      return fee.toFixed(2);
    },
    getTotalFeePerent() {
      let totalFeePercent;
      totalFeePercent =
        (this.previewData.sourceAmount *
          this.previewData.targetPrice *
          this.feeTax.fee) /
        100;

      return totalFeePercent;
    },
    getTotal() {
      let result;
      let feeForMtm;
      let fee = this.getTotalFeePerent();

      console.log(fee, "hereeee");

      if (fee > this.feeFixed.fee) {
        feeForMtm = fee;
      } else {
        feeForMtm = this.feeFixed.fee;
      }

      if (this.redeemtype) {
        result = (
          this.previewData.sourceAmount * this.previewData.targetPrice -
          (this.feeTaxRush.fee + feeForMtm)
        ).toFixed(2);
      } else {
        result = (
          this.previewData.sourceAmount * this.previewData.targetPrice -
          feeForMtm
        ).toFixed(2);
      }

      if (this.redeemInfo.wave) {
        let result1 =
          this.previewData.sourceAmount * this.previewData.targetPrice;
        if (result1 <= this.redeemInfo.waveRule) {
          result = (
            this.previewData.sourceAmount * this.previewData.targetPrice -
            2
          ).toFixed(2);
        }
      }

      return result;
    },
    validateAddress() {
      if (this.usdtAddress.length < 10 || this.usdtAddress.charAt(0) != "T") {
        this.blockButton = true;
      } else {
        this.blockButton = false;
      }
    },

    callNextStep() {
      this.validateAddress();

      console.log('qqqq')

      if (this.checked) {


        console.log(this.redeemtyp, 'red')
        if (this.redeemtype) {
          let total = this.previewData.sourceAmount * this.previewData.targetPrice;
          let feeCompare = this.feeTaxRush.fee;

          if (this.redeemInfo.wave) {
            if (total <= this.redeemInfo.waveRule) {
              feeCompare = 2
            }
          }


          console.log(feeCompare, 'aqqqqqq')

          if (total < feeCompare) {
            Swal.fire(
              {
                icon: "error",
                title: this.$t("msg.error"),
                text: this.$t("msg.invalid_amount"),
              },
              2000
            );
          } else {
            this.$emit("callNext", this.usdtAddress);
          }
        } else {
          let total = this.previewData.sourceAmount * this.previewData.targetPrice;
          let feeCompare = this.feeTaxRush.fee;

          if (this.redeemInfo.wave) {
            if (total <= this.redeemInfo.waveRule) {
              feeCompare = 2
            }
          }

          if (total < feeCompare) {
            Swal.fire(
              {
                icon: "error",
                title: this.$t("msg.error"),
                text: this.$t("msg.invalid_amount"),
              },
              2000
            );
          } else {
            this.$emit("callNext", this.usdtAddress);
          }
        }
      }
    },

    callBackStep() {
      this.$emit("resetStep");
    },

    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;

        return (totalBalance - lockedBalace).toFixed(6);
      }
    },

    async getRedeemFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "redeem") {
          arrayFee.push(fees[i].fee);
        }
      }

      // this.feeRedeem = arrayFee[arrayFee.length - 1];
      this.feeRedeem = 0.001;
    },
  },
  computed: {
    ...mapGetters([
      "member",
      "currencies",
      "bluAccount",
      "btcAccount",
      "bluValue",
      "btcValue",
    ]),
  },
  watch: {},
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/RedeemStep25.vue